import * as React from "react";
import { Link } from "react-router-dom";
import { Organization } from "../../organizations/types";
import { BrowserView, MobileView } from "react-device-detect";
import { User, canManagePatients } from "../../session/types";

interface OwnProps {
  orgs: Organization[] | null;
  selectedOrganization: Organization | null;
  user: User | null;
}

interface OwnState {}

type Props = OwnProps;

class DashboardActions extends React.PureComponent<Props, OwnState> {
  public constructor(props: Props) {
    super(props);
  }

  public render() {
    const { orgs, selectedOrganization, user } = this.props;
    return (
      <>
        <BrowserView>
          <div className="dashboard-actions">
            {orgs && orgs.length > 1 && (
              <Link to="/changeOrganization/" className="flex-1 flex-center">
                <button className="light-border flex-1 flex-center">
                  <div className="flex-1 ellipsis">{selectedOrganization?.name}</div>
                  <i className="fas fa-caret-down ml-5"></i>
                </button>
              </Link>
            )}
            <div
              className={
                "flex-2 " + (orgs && orgs.length > 1 ? "flex-justify-center" : "flex-center")
              }
            >
              {canManagePatients(user) && (
                <Link to="/patient/add/">
                  <button>
                    <i className="far fa-plus-circle btn-icon" /> Add Patient
                  </button>
                </Link>
              )}
              {user && user.featureFlags?.enablePatientUpload && (
                <Link to="/uploadPatients/" className="ml-15">
                  <button>
                    <i className="far fa-cloud-upload btn-icon" /> Upload Patients
                  </button>
                </Link>
              )}
            </div>
            {!selectedOrganization?.smsCommunicationDisabled && (
              <div className="flex-1 flex-end">
                <Link to="/quickContact/">
                  <button>
                    <i className="far fa-user btn-icon" /> Quick Contact
                  </button>
                </Link>
              </div>
            )}
          </div>
        </BrowserView>
        <MobileView>
          <div className="p-15">
            {orgs && orgs.length > 0 && (
              <Link to="/changeOrganization/">
                <button className="light-border full-width">
                  <div className="flex-center">
                    <div className="ellipsis">{selectedOrganization?.name}</div>
                    <i className="fas fa-caret-down ml-5"></i>
                  </div>
                </button>
              </Link>
            )}
            <div className="dashboard-actions">
              {canManagePatients(user) && (
                <Link to="/patient/add/">
                  <button>
                    <i className="far fa-plus-circle btn-icon" /> Add Patient
                  </button>
                </Link>
              )}
              {!selectedOrganization?.smsCommunicationDisabled && (
                <Link to="/quickContact/">
                  <button>
                    <i className="far fa-user btn-icon" /> Quick Contact
                  </button>
                </Link>
              )}
            </div>
          </div>
        </MobileView>
      </>
    );
  }
}

export default DashboardActions;
